module.exports = __webpack_public_path__ + "img/step48_down.47c484a2.png";